import './App.css'
import React from 'react'
import { useWindowSize } from 'usehooks-ts'
import { Recommend } from './components/Recommend/Recommend'
import { Services } from './components/Service/Services'

import { ServiceCategory } from './types'
import { Book } from './components/Book/Book'
import { Main } from './components/Main/Main'
import { ConfigProvider, FloatButton, theme } from 'antd'
import huHU from 'antd/locale/hu_HU'
import { useMemo } from 'react'
import { ResponsiveContext } from './context/responsive-context'
import { Map } from './components/Map/Map'
import { Giftcard } from './components/Giftcard/Giftcard'
import { Reviews } from './components/Reviews/Reviews'
import { Company } from './components/Company/Company'
import { Impressum } from './components/Impressum/Impressum'
import { AboutLanding } from './components/About/AboutLanding'
import { About } from './components/About/About'
import { Details } from './components/Service/Details'
import { Connect } from './components/Service/Connect'
import { Story } from './components/About/Story'
import { Points } from './components/About/Points'

function App() {
  const { width } = useWindowSize()
  const { token } = theme.useToken()
  const isMobile = useMemo(() => width < token.screenXSMax, [width, token.screenXSMax])
  const useVertical = token.screenLGMin > width
  return (
    <ConfigProvider locale={huHU} theme={{
      token: {
        screenSM: 577,
        screenSMMin: 577,
        screenXSMax: 576,
        screenLG: 1110,
        screenLGMin: 1110,
        screenMDMax: 1109,
        fontFamily: 'Gilroy',
        colorPrimary: 'rgb(93, 63, 45)',
      },
      components: {
        Radio: {
          buttonBg: 'rgb(255,255,255,0.25)',
          buttonCheckedBg: 'rgb(255,255,255,0.85)',
        },
        Button: {
          fontFamily: 'Gilroy'
        },
        Input: {
          fontFamily: 'Gilroy'
        },
        Select: {
          fontFamily: 'Gilroy'
        }
      }
    }}>
    <ResponsiveContext value={{
      isMobile,
      useVertical
    }}>
    <div className="App">
      <div className="App-body">
        <div className="Default-container">
          <Main />
        </div>
        <div id="color">
          <div className="Default-container">
            <Recommend category={'color' as ServiceCategory}/>
          </div>
            <Services category={'color' as ServiceCategory}/>
          <div className="Default-container">
            <Connect />
          </div>
          <div className="Default-container">
            <Details category={'color' as ServiceCategory}/>
          </div>
        </div>
        <div className="Default-container">
          <Reviews />
        </div>
        <div id="body">
          <div className="Default-container">
          <Recommend category={'body' as ServiceCategory}/>
          </div>
          <Services category={'body' as ServiceCategory}/>
          <div className="Default-container">
            <Connect />
          </div>
          <div className="Default-container">
            <Details category={'body' as ServiceCategory}/>
          </div>
        </div>
        <div id="gift" className="Default-container">
          <Giftcard />
        </div>
        <div id="other">
          <Services category={'other' as ServiceCategory}/>
        </div>
        <Map />
        <div id="company" className="Default-container">
          <Company />
        </div>
        <div id="aboutlanding" className="Default-container">
          <AboutLanding />
        </div>
        <Book />
        <div id="about">
          <div className={useVertical ? "Default-container-vertical" : "Default-container"}>
            <About />
          </div>
          <div className={useVertical ? "Default-container-vertical" : "Default-container"}>
            <Story />
          </div>
          <div className={useVertical ? "Default-container-vertical" : "Default-container"}>
            <Points />
          </div>
        </div>
        <Impressum />
        <FloatButton.BackTop />
      </div>
    </div>
    </ResponsiveContext>
    </ConfigProvider>
  )
}

export default App
